import { FC, useCallback, useState } from "react";
import { Site } from "../../../lib/src/api/partner/models/Site";
import { config as appConfig } from "../config";
import { Input } from "../../../lib/src/components/form/Input";
import { ModalFooter } from "../../../lib/src/components/layout/ModalProvider";
import { useApiClient } from "../../../lib/src/api";
import { useRealtimeDeployments } from "../components/deployments/RealtimeDeployments";
import { useRefresh } from "../../../lib/src/components/RefreshController";
import moment from "moment";

export const DeleteSiteModal: FC<{ entity: Site }> = (props) => {
  const { partnerClient } = useApiClient(appConfig)
  const { awaitNextDeploymentFinished } = useRealtimeDeployments()!
  const refresh = useRefresh()
  const [date, setDate] = useState<Date>(moment().add(1, 'day').toDate())

  const del = useCallback(async () => {
    const deployment = await partnerClient.deleteSite(props.entity.id, moment(date).format("YYYY-MM-DD"))
    if (deployment.success) {
      await awaitNextDeploymentFinished(deployment.data.id)
    }
    refresh()
  }, [props.entity, date, partnerClient, awaitNextDeploymentFinished, refresh])

  return <div>
    <Input
      type={'date'}
      label={'Date of removal'}
      min={moment().add(1, 'day').toDate()}
      max={moment().add(1, 'year').toDate()}
      value={date}
      onChange={setDate}
    />
    <ModalFooter text={"Delete"} onSubmit={del} />
  </div>
}
